import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import './styles.scss';
import AnnexusLogoSVGR from '../../assets/svgr/AnnexusLogoSVGR';
import NorthAmericanMenuSVGR from '../../assets/svgr/NorthAmericanMenuSVGR';

const Footer = () => (
  <footer className='footer-container'>
    <Container>
      <Grid
        container
        direction='row'
        justifyContent='flex-start'
        alignItems='center'
      >
        <Grid item mobile={12} pl={12} className='grid-footer'>
          <p>
            <sup>1</sup>
            {' '}
            The PlanGap&reg; Benefit is one of four benefits available through the Retirement Benefits rider within Secure Horizon Plus.
            The Retirement Benefit rider includes a rider charge that is deducted from the accumulation annually. Only one benefit
            may be elected under the rider. Once a benefit is elected, no other benefits are available. The PlanGap&reg; Benefit is known
            as the Income Gap Benefit in the contract. PlanGap&reg; is a registered trademark of PlanGap, LLC and is used pursuant to a license.
          </p>
          <p>
            <sup>2</sup>
            {' '}
            It is important to note that a reduction in benefits is only one possible solution. The Social Security administration could increase
            taxation, raise the full retirement age and implement a means-test that would reduce benefits for high earners, or any combination
            of these four possibilities.
          </p>
          <br />
          <p>
            Source: The 2025 Annual Report of the Board of Trustees of the Federal Old-Age and Survivors Insurance and Federal Disability
            Insurance Trust Funds.
          </p>
          <p>
            The results from the Lifetime Social Security Estimator are not a recommendation to buy, sell, hold or roll over any asset, adopt a
            financial strategy or use a particular account type. It does not take into account the specific investment objectives, tax and
            financial condition or particular needs of any specific person. Clients should work with their financial professional to discuss
            their specific situation.
          </p>
          <p>
            The Lifetime Social Security Estimator was created for educational use only. The calculations are based on the information you
            provided and have been generated by PlanGap&reg; and are believed to be reliable. North American makes no guarantee as to the accuracy
            of the calculations or the applicability to your individual circumstances and cannot be held liable for loss resulting from the
            use of information provided by this analysis.
          </p>
          <p>
            The general assumptions used in this tool may change over time and do not represent actual Social Security results, do not
            guarantee future results, and do not represent a recommendation from North American, Annexus, PlanGap&reg; or any of their affiliates.
            Please see the Social Security Administration’s website at
            {' '}
            <a href='https://www.ssa.gov/' target='_blank' rel='noreferrer'>www.ssa.gov</a>
            {' '}
            for more information, restrictions, and limitations regarding Social Security benefits.
          </p>
          <p>
            The term financial professional is not intended to imply engagement in an advisory business in which compensation is not
            related to sales. Financial professionals that are insurance licensed will be paid a commission on the sale of an insurance product.
          </p>
          <p>
            Neither North American Company for Life and Health Insurance&reg; nor any of its affiliates are affiliated with PlanGap&reg; or
            the Social Security Administration. North American&apos;s product(s) are not sponsored, endorsed, sold or promoted
            by the Social Security Administration, and they make no representation regarding the advisability of purchasing of the product(s).
          </p>
          <p>
            Annexus and their affiliated agencies are independently contracted with North American Company for Life and Health Insurance.
          </p>
          <p>
            Fixed index annuities are not a direct investment in the stock market. They are long term insurance products with guarantees
            backed by the issuing company. They provide the potential for interest to be credited based in part on the performance
            of specific indices, without the risk of loss of premium due to market downturns or fluctuation. Although fixed index
            annuities guarantee no loss of premium due to market downturns, deductions from your accumulation value for optional
            benefit riders or strategy fees or charges associated with allocations to enhanced crediting methods could exceed interest
            credited to the accumulation value, which would result in loss of premium. They may not be appropriate for all clients.
            Interest credits to a fixed index annuity will not mirror the actual performance of the relevant index.
          </p>
          <p>
            The North American Secure Horizon
            <sup>SM</sup>
            {' '}
            Plus is issued on form NA2001A/ICC24-NA2001A (contract), AE692A/ICC24-AE692A.PB, AE652A/ICC21-AE652A, AE654A/ICC21-AE654A,
            AE655A/ICC21-AE655A, AE642A/ICC20-AE642A, AE638A/ICC21-AE638A, AE695A/ICC24-AE695A, AE703A, AE704A, AE705A/ICC25-AE705A
            (riders/endorsements) or appropriate state variation. This product, its features and riders may not be available
            in all states or appropriate for all clients.
          </p>
          <p>
            Sammons Financial&reg; is the marketing name for Sammons&reg; Financial Group, Inc.’s member companies, including North American
            Company for Life and Health Insurance&reg;. Annuities and life insurance are issued by, and product guarantees are solely the
            responsibility of, North American Company for Life and Health Insurance.
          </p>
          <p className='left'>
            34709Z-2
          </p>
          <p className='right'>
            REV 3-26
          </p>
        </Grid>
      </Grid>
      <Grid
        container
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        mb={{ xs: 6, sm: 4 }}
        mt={{ xs: 5, sm: 0 }}
      >
        <NorthAmericanMenuSVGR />
        <AnnexusLogoSVGR />
      </Grid>
    </Container>

  </footer>
);

export default Footer;
